import { VARIATION_PDP } from '@kissui/components/src/sku/constants'
import viewportHelper from '@kissui/helpers/src/viewport.helpers'

const isPdp = variation => variation === VARIATION_PDP

const getHeadingLevel = ({ variation }) => (isPdp(variation) ? 'h1' : 'h3')

const renderLink = ({ url, a11y_product_card = '', name = '', name_custom = '' }) => {
    const a11yProductName = a11y_product_card.replace('{productName}', name)
    const productName = name_custom !== '' ? name_custom : name

    return `<a href="${url}" target="_self" title="${a11yProductName}" aria-label="${a11yProductName}">${productName}</a>`
}

export const renderHeading = props => {
    const { url, name = '', name_custom = '' } = props

    if (!name) {
        return ''
    }

    const finalName = name_custom !== '' ? name_custom : name
    const result = []
    const headingLevel = getHeadingLevel(props)

    result.push(
        `<${headingLevel} class="cb-heading ${
            viewportHelper.is.mobile ? 't-md-700-sl' : 'h-lg-700'
        }">`
    )

    if (url && !isPdp(props.variation)) {
        result.push(renderLink(props))
    } else {
        result.push(`${finalName}`)
    }

    result.push(`</${headingLevel}>`)

    return result.join('')
}
